"use strict";

class ScribdDocumentTracker {
  static initClass() {
    this.loadedAt = /* @__PURE__ */new Date();
  }
  constructor(attachmentId, docView) {
    let throttleInterval;
    this.attachmentId = attachmentId;
    this.docView = docView;
    _.extend(this, Backbone.Events);
    this.events = [];
    this.pagesViewed = {};
    this.listenTo(this.docView, "docReady", this.recordDocumentReady);
    this.listenTo(this.docView, "pageChanged", this.recordPageChange);
    $(window).on("beforeunload", () => this.recordUnload());
    if (window.navigator.sendBeacon != null && window.FormData != null) {
      this.sendData = function (url, data) {
        const fd = new FormData();
        _.each(data, (val, key) => fd.append(key, val));
        const success = navigator.sendBeacon(url, fd);
        if (!success) {
          return $a.log(`sendBeacon failed for: ${JSON.stringify(data)}`);
        }
      };
      throttleInterval = 15e3;
    } else {
      this.sendData = $.post;
      throttleInterval = 1e3;
    }
    this.flushEventsThrottled = _.throttle(() => this.flushEvents(), throttleInterval);
  }
  recordDocumentReady(e) {
    this.enqueueEvent("docReady", this.docView.getPage());
    return this.flushEventsThrottled();
  }
  recordPageChange(e) {
    this.enqueueEvent("pageChanged", e.page);
    return this.flushEventsThrottled();
  }
  // This won't be 100% reliable, but that's ok, we also flush periodically
  // and this just improves our best-effort strategy
  recordUnload() {
    this.enqueueEvent("unload", this.docView.getPage());
    this.flushEvents(false);
  }
  enqueueEvent(event, page) {
    return this.events.push({
      event,
      ms_since_load: (/* @__PURE__ */new Date()).getTime() - this.constructor.loadedAt,
      page
    });
  }
  flushEvents(async) {
    if (async == null) {
      async = true;
    }
    if (!(this.events.length > 0)) {
      return;
    }
    if (!Aedu.hit_data && async) {
      setTimeout(() => this.flushEventsThrottled(), 500);
      return;
    }
    this.sendData($r.api_v0_scribd_events_path({
      subdomain_param: "api"
    }), {
      hit: JSON.stringify(Aedu.hit_data),
      attachment_id: this.attachmentId,
      events: JSON.stringify(this.events)
    });
    if (Aedu.hit_data) {
      for (const event of this.events) {
        if (event.event !== "pageChanged") {
          continue;
        }
        if (this.pagesViewed[event.page]) {
          continue;
        }
        this.pagesViewed[event.page] = true;
        $.ajax({
          url: $r.api_v0_views_path({
            subdomain_param: "api"
          }),
          type: "POST",
          dataType: "json",
          contentType: "application/json",
          data: JSON.stringify({
            hit_id: Aedu.hit_data.id,
            impression_time: /* @__PURE__ */new Date(),
            entity_id: this.attachmentId,
            entity_type: 17,
            // ImpressionEntity.AttachmentPage
            source: "scribd_document_tracker",
            extra: {
              page: event.page,
              ms_since_load: event.ms_since_load
            }
          })
        });
      }
    }
    return this.events = [];
  }
}
ScribdDocumentTracker.initClass();
if (window.Aedu) {
  window.Aedu.ScribdDocumentTracker = ScribdDocumentTracker;
}
window.ScribdDocumentTracker = ScribdDocumentTracker;